import React, { useCallback, useState, useMemo } from "react";
import { Modal, Button, Form, Input, InputNumber, Icon, Space, Message } from '@tinper/next-ui';
import i18n from "../i18n";
import './index.less';

// const { getLangInfo } = Locale;

const danger = function (info: string) {
  Message.destroy();
  Message.create({ content: info, color: 'danger' });
};

const UploadUrlModal = (props: any) => {
  const {
    showModal,
    handleModalShow,
    editor,
    locale
  } = props;
  const [form] = Form.useForm();
  // const [lock, setLock] = useState(true);
  const [ratio, setRatio] = useState(null);
  // const [widthDisabled, setWidthDisabled] = useState(false);
  // const [heightDisabled, setHeightDisabled] = useState(false);

  useMemo(() => {
    if (showModal) {
      form.resetFields()
    }
  }, [showModal])

  const onClose = useCallback(() => {
    handleModalShow && handleModalShow(false);
    form.resetFields()
  }, [form])

  const onSubmit = useCallback(() => {
    form.validateFields(['path']).then((values: any) => {
      const { path, describe = '', width, height } = values;

      const newImg = document.createElement('img');
      newImg.src = path;
      const id = new Date().toDateString()
      newImg.setAttribute('id', id);
      newImg.setAttribute('style', 'visibility: hidden')
      newImg.onload = () => {
        const html = `<img src='${path}' alt='${describe}' style='width: ${width}px; height: ${height}px' />`;
        editor.insertContent(html);
        handleModalShow && handleModalShow(false);
        document.body.removeChild(newImg);
      }
      newImg.onerror = () => {
        danger(`${localeTaget.langMap.theImageFailedToLoad || '图片加载失败'}`)
        document.body.removeChild(newImg);
      }
      document.body.appendChild(newImg);

      // const html = `<img src='${path}' alt='${describe}' style='width: ${width}px; height: ${height}px' />`;
      // editor.insertContent(html);
      // handleModalShow && handleModalShow(false);
    });
  }, [editor, form])

  const onFieldsChange = (changedFields: any, allValues: any) => {
    const { errors, name, value } = changedFields[0];
    if (name[0] === 'path' && errors.length === 0 && value) {
      // todo img 地址校验 http 格式
      const newImg = document.createElement('img');
      newImg.src = value;
      const id = new Date().toDateString()
      newImg.setAttribute('id', id);
      newImg.setAttribute('style', 'visibility: hidden')
      newImg.onload = () => {
        const currentImage = document.getElementById(id);
        form.setFieldsValue({ width: currentImage?.offsetWidth, height: currentImage?.offsetHeight });
        currentImage?.offsetWidth && setRatio((currentImage?.offsetWidth as number / currentImage?.offsetHeight as number).toFixed(2))
        document.body.removeChild(newImg);
      }
      newImg.onerror = () => {
        // danger(`${localeTaget.langMap.theImageFailedToLoad || '图片加载失败'}`)
        document.body.removeChild(newImg);
      }
      document.body.appendChild(newImg);
      return;
    }
    const width = allValues.find((it: any) => it.name[0] === 'width')?.value;
    const height = allValues.find((it: any) => it.name[0] === 'height')?.value;
    if (name[0] === 'width' && ratio && height !== Math.floor(width / ratio)) {
      form.setFieldsValue({ height: Math.floor(width / ratio) })
      return;
    };
    if (name[0] === 'height' && ratio && width !== Math.floor(height * ratio)) {
      form.setFieldsValue({ width: Math.floor(height * ratio) })
    };
  }
  // const handleLock = useCallback(() => {
  //   setLock(!lock)
  // }, [lock])
  const localeTaget = useMemo(() => {
    // return getLangInfo(locale, i18n)
    const target = {}
    // @ts-ignore
    target.langMap = i18n[locale || 'zh-cn'] || {};
    return target;
  }, [locale])

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 }
  };

  return (
    <Modal className="url-modal" autoFocus='.coustomFocus' visible={showModal} destroyOnClose={true} onCancel={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{localeTaget.langMap.insertImageThroughURL || '通过URL插入图像'}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form
          form={form}
          {...layout}
          onFieldsChange={onFieldsChange}
        >
          <Form.Item
            label={`${localeTaget.langMap.picturePath || '图片路径'}`}
            name='path'
            rules={[
              {
                required: true,
                message: `${localeTaget.langMap.thePathCannotBeEmpty || '路径不能为空'}`
              }
            ]}
          >
            <Input placeholder={`${localeTaget.langMap.pleaseEnter || '请输入'}`} />
          </Form.Item>
          <Form.Item label={`${localeTaget.langMap.pictureDescription || '图片描述'}`} name='describe'>
            <Input placeholder={`${localeTaget.langMap.pleaseEnter || '请输入'}`} />
          </Form.Item>
          <Space size={12} style={{ position: 'relative' }} className="img-size">
            <Form.Item label={`${localeTaget.langMap.imageSize || '图片尺寸'}`} name='width' labelCol={{ span: 9 }} wrapperCol={{ span: 14 }} style={{ marginLeft: '2px' }}>
              <InputNumber placeholder={`${localeTaget.langMap.width || '宽度'}`} />
            </Form.Item>
            <span className="img-lock">
              <Icon type="uf-dongjie" />
              {/* { lock ? <Icon type="uf-dongjie" /> : <Icon type="uf-weidongjie" />} */}
            </span>
            <Form.Item label=''name='height' wrapperCol={{ span: 18 }}>
              <InputNumber placeholder={`${localeTaget.langMap.height || '高度'}`} />
            </Form.Item>
          </Space>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} colors="secondary" style={{ marginRight: 8 }}>{localeTaget.langMap.cancel || '取消'}</Button>
        <Button className='coustomFocus' onClick={onSubmit} colors='primary'>{localeTaget.langMap.ok || '确定'}</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UploadUrlModal;